
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M7.08 58.33l-5.34-6.38h56.52l-5.34 6.38H7.08zM13.08 51.71a13.82 13.82 0 01-4.73-10.43V17.22h39.3v24.06a13.85 13.85 0 01-5 10.64"}}),_c('path',{attrs:{"d":"M47.51 24.22h8.75v11.41c0 5.83-9.39 10.28-9.39 10.28M47.16 38.22H8.84M19.78 4.75v8.33M28 .67v12.41M36.22 4.75v8.33","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    